import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=171bef08&scoped=true"
import script from "./Alertas.vue?vue&type=script&lang=js"
export * from "./Alertas.vue?vue&type=script&lang=js"
import style0 from "./Alertas.vue?vue&type=style&index=0&id=171bef08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171bef08",
  null
  
)

export default component.exports